export default "__VITE_PUBLIC_ASSET__6e6fe619__"